






























import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import TeamCard from "./team-card.vue";
import TeamCopy from "./team-copy.vue";
import TeamSetup from "./team-setup.vue";
import Modal from "../../components/common/confirm.js";

export default Vue.extend({
  name: "TeamList",
  components: {
    TeamCard,
    TeamCopy,
    TeamSetup,
  },
  props: {
    selectedMemberId: {
      type: Number,
      default: NaN,
      required: true,
    },
    personalTeamFilter: {
      type: String,
      default: "All Teams",
      required: false,
    },
  },
  data() {
    return {
      showTeamCopy: false,
      showTeamSetup: false,
      copyingTeam: null,
      edittingTeam: {
        id: null,
        name: null,
        color: null,
        completedPercentage: null,
        description: null,
        hashTags: null,
        completed: false,
        grantedPermissions: [],
        members: [],
      },
      edittingOriginalTeam: null,
      archiveOrDeleteTeam: null,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    personalTeamResults(): any {
      let groups = [];
      let allTeams = this.$store.state.team.myTeams;
      let teams = allTeams || [];
      let hashTagFilter = null;

      if (this.selectedMemberId !== NaN) {
        teams = teams.filter((team) => team.members && team.members.filter((member) => member.memberId === this.selectedMemberId).length > 0);
      }

      let tags = [];
      if (this.personalTeamFilter && this.personalTeamFilter.startsWith("#")) {
        hashTagFilter = this.personalTeamFilter.replace("#", "");
        teams = teams.filter((team) => team.hashTagList && team.hashTagList.filter((tag) => tag.text === hashTagFilter).length > 0);

        tags = [hashTagFilter];
      } else {
        if (this.personalTeamFilter === "Completed Teams") {
          teams = teams.filter((team) => team.completed === true);
        } else if (this.personalTeamFilter === "Active Teams") {
          teams = teams.filter((team) => team.completed === false);
        }

        tags = this.getHashTags(teams);
      }

      let noHashTagTeams = teams.filter((team) => !team.hashTagList || team.hashTagList.length < 1);

      if (noHashTagTeams.length > 0) {
        groups.push({
          title: "No # Tags",
          teams: noHashTagTeams,
        });
      }

      tags = tags.sort();

      tags.forEach((hashTag) => {
        let tagedTeams = teams.filter((team) => team.hashTagList && team.hashTagList.filter((tag) => tag.text === hashTag).length > 0);

        if (tagedTeams.length > 0) {
          groups.push({
            title: hashTag,
            teams: teams.filter((team) => team.hashTagList && team.hashTagList.filter((tag) => tag.text === hashTag).length > 0),
          });
        }
      });

      if (groups.length == 0) {
        groups.push({
          title: "No # Tags",
          teams: [],
        });
      }

      return groups;
    },
    hashTags() {
      let hashTags = [];
      let allTeams = this.$store.state.team.myTeams || [];
      allTeams.forEach((team) => {
        hashTags = hashTags.concat(team.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
  },
  methods: {
    getHashTags(teams) {
      let hashTags = [];
      teams.forEach((team) => {
        hashTags = hashTags.concat(team.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
    encodeName(hashTag, name) {
      return `${hashTag}--${name}`;
    },
    showTeamCreator() {
      let user = (this as any).user;
      this.edittingTeam = {
        id: null,
        name: null,
        color: null,
        completedPercentage: null,
        description: null,
        hashTags: "",
        completed: false,
        grantedPermissions: ["Bio.AssignAuthorRole", "Bio.AssignFan"],
        members: [{ memberId: user.id, memberName: user.nameName, memberEmailAddress: user.memberEmailAddress, memberAvatarImageUrl: user.memberAvatarImageUrl, role: 6, accepted: true }],
      };
      this.showTeamSetup = true;
    },
    handleCancelTeamCopy() {
      this.showTeamCopy = false;
    },
    handleCancelNewTeam() {
      this.showTeamSetup = false;
    },
    showDeleteDialog(team) {
      let context = this as any;
      Modal.confirm({
        title: "Delete team?",
        content: "<p>When you delete a team it will be gone for good. After it is deleted the team cannot be restored.</p>",
        okText: "Delete this team",
        cancelText: "Never mind",
        onOk: () => {
          context.handleDelete(team);
        },
        onCancel: () => {},
      });
    },
    handleDelete(team) {
      this.$store.dispatch("team/delete", { data: team }).then(() => {});
    },
    markComplete(team, completed) {
      team.completed = completed;
      this.$store.dispatch("team/update", { data: team }).then(() => {});
    },
    handleOpenTeamEditor(team) {
      this.edittingTeam = {
        id: team.id,
        name: team.name,
        color: team.color,
        completedPercentage: team.completedPercentage,
        description: team.description,
        hashTags: team.hashTags,
        completed: team.completed,
        grantedPermissions: team.grantedPermissions,
        members: team.members,
      };

      this.edittingOriginalTeam = team;
      this.showTeamSetup = true;
    },
    handleTeamCopy(team) {
      this.copyingTeam = {
        id: team.id,
        name: team.name,
        description: team.description,
        hashTags: team.hashTags,
      };

      this.showTeamCopy = true;
    },
    handleRestore(team) {
      this.$store.dispatch("team/unarchive", { data: team }).then((response) => {});
    },
  },
});
